import { gql } from "@apollo/client";

const schema = {
  list: {
    name: 'orderAttachment',
    serviceName: 'auth',
    query: gql`
      query orderAttachment(
        $ids: [String]
        $title: String
        $order_ids: [String]
        $lab_ids: [String]
        $unit_ids: [String]
        $creator_id: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        orderAttachment(
          ids: $ids
          title: $title
          order_ids: $order_ids
          lab_ids: $lab_ids
          unit_ids: $unit_ids
          creator_id: $creator_id
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            title
            price
            number
            status
            total_price
            lab {
              id
              title
            }
            unit {
              id
              title
            }
            media {
              id
              full_url
            }
          }
          total
          last_page
        }
      }
    `,
  },
  assignment: {
    name: "orderAttachment",
    serviceName: "auth",
    query: gql`
      query orderAttachment($ids: [String]) {
        orderAttachment(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
